<template>

    <simple-layout-v2
        :models-loaded="true"
        :class="customClass"
        :headerHeight="$store.getters.simpleLayoutV2Heigth"
        img="../../../../static/image/simple-layout-img.png"
    >
        <template slot="header-content">
            <ns-loader
                ref="nsLoader"
                :to-load="toLoad"
                :fetchTimer="10000"
                :scoped="false"
                class="simple-layout-header-section"
                @dataFetched="onDataFetched"
            >
                <ns-loader-spinner slot="loader"></ns-loader-spinner>
                <div slot="content">
                    <div class="simple-layout-header-data">
                        <layout-indicator
                            :percent="errorPercent"
                            :resourceNumber="errorNumber"
                            :text="errorNumber > 1 ? 'errors' : 'error'"
                            color="#f56C6C"
                        ></layout-indicator>
                        <layout-indicator
                            :percent="warningPercent"
                            :resourceNumber="warningNumber"
                            :text="warningNumber > 1 ? 'warnings' : 'warning'"
                            color="#E6A23C"
                        ></layout-indicator>
                        <layout-indicator
                            :percent="successPercent"
                            :resourceNumber="successNumber"
                            text="success"
                            color="#67C23A"
                        ></layout-indicator>
                        <div
                            class="circle-section incoming-feeds"
                            v-if="relatedResource === 'channel'"
                        >
                            <div class="border-circle"></div>
                            <div class="circle-info">
                                <div class="value">{{channelsOff}}</div>
                                <div class="text" style="width: 142px;">Off</div>
                            </div>
                        </div>
                        <div
                            class="circle-section incoming-feeds"
                            v-else-if="relatedResource === 'feed'"
                        >
                            <div class="border-circle"></div>
                            <div class="circle-info">
                                <div class="value">{{feedsIncoming}}</div>
                                <div class="text" style="width: 142px;">Incoming</div>
                            </div>
                        </div>
                    </div>
                    <div class="header-bottom">
                        <div class="navigation">
                            <el-button
                                class="gmcn-btn-icon"
                                icon="el-icon-s-home"
                                size="mini"
                                @click="$router.push('/')"
                                circle
                            ></el-button>
                            <span class="simple-layout-title">{{ title }}</span>
                        </div>
                        <slot name="action-btn"></slot>
                    </div>
                </div>
            </ns-loader>
        </template>
        <slot></slot>
    </simple-layout-v2>
</template>

<script>

import SimpleLayoutV2 from 'fundation-app-vuejs/src/components/partials/simple-layout-v2';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import NsLoaderSpinner from './ns-loader-template.vue';
import LayoutIndicator from './layout-indicator.vue';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {

    components: {
        SimpleLayoutV2,
        NsLoader,
        NsLoaderSpinner,
        LayoutIndicator
    },

    props: {
        title: {
            type: String,
            default: '',
        },
        customClass: {
            type: String,
            default: '',
        },
    },

    data (){
        return {
            contentLoaded: false,
            percent: 20,
            feedsFailed: [],
            feedMonitorsCritical: [],
            feedMonitorsWarning: 0,
            feedMonitorsOk: 0,
            feedsIncoming: 0,
            channelsFailed: [],
            channelMonitorsCritical: [],
            channelMonitorsWarning : 0,
            channelMonitorsOk: 0,
            channelsOff: 0,
            relatedResource:'',
        };
    },

    computed: {
        ...mapGetters([
            'userIsAtLeastAdmin',
            'userIsEntityAdmin',
            'administrableEntitiesUids'
        ]),
        totalNumber() {
            if(this.relatedResource === 'feed'){
                return this.feedsErrorNumber + this.feedsWarningNumber + this.feedsSuccessNumber;
            }
            if(this.relatedResource === 'channel'){
                return this.channelsErrorNumber + this.channelMonitorsWarning + this.channelsSuccessNumber;
            }
            let feedsTotal = this.feedsErrorNumber + this.feedsWarningNumber + this.feedsSuccessNumber;
            let channelsTotal = this.channelsErrorNumber + this.channelMonitorsWarning + this.channelsSuccessNumber;
            return feedsTotal + channelsTotal;
        },
        successNumber(){
            let successNumber = 0;
            if(this.relatedResource === 'feed'){
                successNumber = this.feedsSuccessNumber;
            } else if(this.relatedResource === 'channel'){
                successNumber = this.channelsSuccessNumber;
            } else{
                successNumber = this.feedsSuccessNumber + this.channelsSuccessNumber
            }
            return successNumber;
        },
        successPercent() {
            if (this.successNumber === 0) {
                return 0;
            }
            return 100 * this.successNumber / this.totalNumber;
        },
        warningNumber(){
            let warningNumber = 0;
            if(this.relatedResource === 'feed'){
                warningNumber = this.feedsWarningNumber;
            } else if(this.relatedResource === 'channel'){
                warningNumber = this.channelsWarningNumber;
            } else{
                warningNumber = this.feedsWarningNumber + this.channelsWarningNumber;
            }
            return warningNumber;
        },
        warningPercent() {
            if (this.warningNumber === 0) {
                return 0;
            }
            return 100 * this.warningNumber / this.totalNumber;
        },
        errorNumber(){
            let errorNumber = 0;
            if(this.relatedResource === 'feed'){
                errorNumber = this.feedsErrorNumber;
            } else if(this.relatedResource === 'channel'){
                errorNumber = this.channelsErrorNumber;
            } else{
                errorNumber = this.feedsErrorNumber + this.channelsErrorNumber;
            }
            return errorNumber;
        },
        errorPercent() {
            if (this.errorNumber === 0) {
                return 0;
            }
            return 100 * this.errorNumber / this.totalNumber;
        },
        feedsErrorNumber() {
            let errorFeeds = new Set(this.feedsFailed.map(feed => feed.uid));
            this.feedMonitorsCritical.forEach(monitor => {
                errorFeeds.add(monitor.feed_uid);
            });
            return errorFeeds.size;
        },
        feedsWarningNumber() {
            return this.feedMonitorsWarning;
        },
        feedsSuccessNumber() {
            return this.feedMonitorsOk;
        },
        channelsErrorNumber() {
            let errorChannels = new Set(this.channelsFailed.map(channel => channel.uid));
            this.channelMonitorsCritical.forEach(monitor => {
                errorChannels.add(monitor.channel_uid);
            });
            return errorChannels.size;
        },
        channelsWarningNumber() {
            return this.channelMonitorsWarning;
        },
        channelsSuccessNumber() {
            return this.channelMonitorsOk;
        },
        toLoad() {
            let modelsToFetch = [];
            let channelsModelToFetch = [
                {
                    name: 'channelsFailed',
                    model: 'channels',
                    filters: {
                        archived: false,
                        status: 'FAILED',
                        confirmed: true,
                    }
                },
                {
                    name: 'channelMonitorsWarning',
                    model: this.userIsAtLeastAdmin ? 'channelAdminMonitors' : 'channelManagerMonitors',
                    stats: true,
                    filters: {
                        archived: false,
                        global_status: 'WARNING'
                    }
                },
                {
                    name: 'channelMonitorsOk',
                    model: this.userIsAtLeastAdmin ? 'channelAdminMonitors' : 'channelManagerMonitors',
                    stats: true,
                    filters: {
                        archived: false,
                        global_status: 'OK'
                    }
                },
                {
                    name: 'channelsOff',
                    model: 'channels',
                    stats: true,
                    filters: {
                        archived: false,
                        status: 'STOPPED'
                    }
                },
            ];
            let feedsModelToFetch = [
                {
                    name: 'feedsFailed',
                    model: 'feeds',
                    filters: {
                        archived: false,
                        status: 'FAILED',
                        confirmed_start_date__lte: moment().format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
                        confirmed_end_date__gte: moment().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
                    }
                },
                {
                    name: 'feedMonitorsWarning',
                    model: this.userIsAtLeastAdmin ? 'feedAdminMonitors' : 'feedManagerMonitors',
                    stats: true,
                    filters: {
                        archived: false,
                        global_status: 'WARNING'
                    }
                },
                {
                    name: 'feedMonitorsOk',
                    model: this.userIsAtLeastAdmin ? 'feedAdminMonitors' : 'feedManagerMonitors',
                    stats: true,
                    filters: {
                        archived: false,
                        global_status: 'OK'
                    }
                },
                {
                    name: 'feedsIncoming',
                    model: 'feeds',
                    stats: true,
                    filters: {
                        archived: false,
                        // a feed starting is handled by the automation so
                        // it shouldn't appear in the incoming feeds.
                        status__in: 'AVAILABLE,PREPARING'
                    }
                },
            ];
            if(this.userIsAtLeastAdmin){
                channelsModelToFetch.push(
                    {
                        name: 'channelAdminMonitorsCritical',
                        model: 'channelAdminMonitors',
                        filters: {
                            archived: false,
                            global_status: 'CRITICAL'
                        }
                    },
                );
                feedsModelToFetch.push(
                    {
                        name: 'feedAdminMonitorsCritical',
                        model: 'feedAdminMonitors',
                        filters: {
                            archived: false,
                            global_status: 'CRITICAL'
                        }
                    },
                );
            } else if (this.userIsEntityAdmin()){
                channelsModelToFetch.push(
                    {
                        name: 'channelAdminMonitorsCritical',
                        model: 'channelAdminMonitors',
                        filters: {
                            archived: false,
                            global_status: 'CRITICAL'
                        }
                    },

                    {
                        name: 'channelManagerMonitorsCritical',
                        model: 'channelManagerMonitors',
                        filters: {
                            archived: false,
                            global_status: 'CRITICAL'
                        }
                    }
                );
                feedsModelToFetch.push(
                    {
                        name: 'feedAdminMonitorsCritical',
                        model: 'feedAdminMonitors',
                        filters: {
                            archived: false,
                            global_status: 'CRITICAL'
                        }
                    },
                    {
                        name: 'feedManagerMonitorsCritical',
                        model: 'feedManagerMonitors',
                        filters: {
                            archived: false,
                            global_status: 'CRITICAL'
                        }
                    },
                );
            } else {
                channelsModelToFetch.push(
                    {
                        name: 'channelManagerMonitorsCritical',
                        model: 'channelManagerMonitors',
                        filters: {
                            archived: false,
                            global_status: 'CRITICAL'
                        }
                    }
                );
                feedsModelToFetch.push(
                    {
                        name: 'feedManagerMonitorsCritical',
                        model: 'feedManagerMonitors',
                        filters: {
                            archived: false,
                            global_status: 'CRITICAL'
                        }
                    },
                );
            }
            if(this.relatedResource === 'channel'){
                return channelsModelToFetch;
            }else if(this.relatedResource === 'feed'){
                return feedsModelToFetch;
            }else{
                modelsToFetch = [...channelsModelToFetch, ...feedsModelToFetch];
                return modelsToFetch;
            }
        },
    },

    created (){
        if(this.$route.name === 'channels'){
            this.relatedResource = 'channel';
        } else if(this.$route.name === 'feeds' || this.$route.name === 'booking-mismatch'){
            this.relatedResource = 'feed';
        }
    },

    methods: {
        async onDataFetched(res) {
            //feeds
            this.$set(this, 'feedsFailed', res.feedsFailed);
            this.$set(this, 'feedMonitorsWarning', res.feedMonitorsWarning);
            this.$set(this, 'feedMonitorsOk', res.feedMonitorsOk);
            this.$set(this, 'feedsIncoming', res.feedsIncoming);
            //channel
            this.$set(this, 'channelsFailed', res.channelsFailed);
            this.$set(this, 'channelMonitorsWarning', res.channelMonitorsWarning);
            this.$set(this, 'channelMonitorsOk', res.channelMonitorsOk);
            this.$set(this, 'channelsOff', res.channelsOff);

            if(this.userIsAtLeastAdmin){
                this.$set(this, 'feedMonitorsCritical', res.feedAdminMonitorsCritical);
                this.$set(
                    this, 'channelMonitorsCritical', res.channelAdminMonitorsCritical
                );
            }else if(this.userIsEntityAdmin()){
                await this.setCriticalMonitorData(res);
            }else{
                this.$set(this, 'feedMonitorsCritical', res.feedManagerMonitorsCritical);
                this.$set(
                    this, 'channelMonitorsCritical', res.channelManagerMonitorsCritical
                );
            }
            this.contentLoaded = true;
        },
        setCriticalMonitorData(res){
            /*
              If userIsEntityManager we want to get :
              - adminMonitors models currentUser can administrate.
              - managerMonitors models in currentUser's scopes without the ones he can administrate.
            */
            let feedAdminMonitors = res.feedAdminMonitorsCritical.filter(
                monitor =>
                    this.administrableEntitiesUids.includes(monitor.scopes.entity_uid)
            );
            let channelAdminMonitors = res.channelAdminMonitorsCritical.filter(
                monitor =>
                    this.administrableEntitiesUids.includes(monitor.scopes.entity_uid)
            );
            let feedManagerMonitors = res.feedManagerMonitorsCritical.filter(
                monitor =>
                    !this.administrableEntitiesUids.includes(monitor.scopes.entity_uid)
            );
            let channelManagerMonitors = res.channelManagerMonitorsCritical.filter(
                monitor =>
                    !this.administrableEntitiesUids.includes(monitor.scopes.entity_uid)
            );
            let feedMonitors = [...feedAdminMonitors, ...feedManagerMonitors];
            let channelMonitors = [...channelAdminMonitors, ...channelManagerMonitors];
            this.$set(this, 'feedMonitorsCritical', feedMonitors);
            this.$set(this, 'channelMonitorsCritical', channelMonitors);
        },
    },
};
</script>

<style lang="scss">
.simple-layout-header-section {
    width: 100%;
    background-color: transparent;
    .simple-layout-header-data {
        display: flex;
        padding: 10px 10% 30px;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        @media (min-width: 1025px) {
            padding: 30px 10% 50px;
        }
        .incoming-feeds {
            height: 60px;
            width: 60px;
            border-radius: 60px;
            position: relative;
            background-color: rgba(255, 255, 255, 0.2);
            @media (min-width: 1025px) {
                height: 100px;
                width: 100px;
                border-radius: 100px;
            }
            .border-circle {
                background-color: #222;
                position: absolute;
                height: 60px;
                width: 60px;
                border-radius: 60px;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                @media (min-width: 1025px) {
                    height: 100px;
                    width: 100px;
                    border-radius: 100px;
                }
            }
            .circle-info {
                position: absolute;
                height: 50px;
                width: 50px;
                border-radius: 50px;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: #222;
                @media (min-width: 1025px) {
                    height: 90px;
                    width: 90px;
                    border-radius: 90px;
                }
                .value {
                    position: absolute;
                    font-size: 22px;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
                .text {
                    position: absolute;
                    text-align: center;
                    bottom: -35px;
                    font-size: 15px;
                    left: 50%;
                    transform: translate(-50%, 0);
                }
            }
        }
    }
    .header-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .navigation {
            display: flex;
            align-items: center;
            align-self: flex-start;
            .simple-layout-title {
                margin-left: 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/gcmcn-layout.vue